import { AfterViewInit, Component, inject } from '@angular/core';
import { Clipboard } from '@capacitor/clipboard';
import { concatMap } from 'rxjs';
import { EventService } from '../../providers/event/event.service';
import { Logger } from '../../utils/logger';

/**
 * @description App Clipboard.
 * @exports
 * @class ClipboardComponent
 * @implements {AfterViewInit}
 */
@Component({
  selector: 'app-clipboard',
  template: ``,
  standalone: true
})
export class ClipboardComponent implements AfterViewInit {
  private readonly events = inject(EventService);

  private readonly logger = Logger.getInstance(ClipboardComponent.name);

  /**
   * @description Init.
   * @memberof ClipboardComponent
   */
  ngAfterViewInit(): void {
    this.events
      .listen(this.events.keys.COPY)
      .pipe(concatMap((text: string) => Clipboard.write({ string: text })))
      .subscribe({
        /**
         * @description Next.
         */
        next: () => {
          this.events.publish('TOAST_INFO', {
            message: 'Text copied to clipboard!',
            options: {
              icon: 'checkmark-circle-outline',
              duration: 1000
            }
          });
        },
        /**
         * @description Error.
         * @param {unknown} reject Error.
         */
        error: (reject) => {
          this.logger.child(this.ngAfterViewInit.name).error(reject);
          this.events.publish(this.events.keys.TOAST_ERROR, 'Unable to copy!');
        }
      });
  }
}
